






import { Vue, Component, Prop } from "vue-property-decorator";
import { Activity } from "@/graphql/query/activity/feed";
import { GroupUserLink } from "./helper";

@Component({ components: { GroupUserLink } })
export default class DeleteUserLog extends Vue {
  @Prop({ type: Object, required: true }) activity!: Activity;
}
